(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll("[data-announcement-rotator]").forEach(function (rot) {
    var msgs = rot.querySelectorAll(".announcement-bar__msg");
    if (msgs.length < 2 || rot.dataset.rotate === "false") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var i = 0;
    var speed = parseInt(rot.dataset.speed, 10) || 5000;
    setInterval(function () {
      msgs[i].classList.remove("is-active");
      msgs[i].setAttribute("aria-hidden", "true");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-active");
      msgs[i].removeAttribute("aria-hidden");
    }, speed);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["film-comparison"] && !Shopify.designMode) return;
  try {
    
(function () {
  var U = (window.PhantomR && window.PhantomR.utils) || {};
  function animate(scope) {
    if (scope.__cmpInit) return; scope.__cmpInit = true;
    var fills = scope.querySelectorAll(".meter__fill");
    if (!fills.length || !U.animationsOn || !("IntersectionObserver" in window)) return;
    fills.forEach(function (f) { f.style.width = "0%"; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        scope.querySelectorAll(".meter__fill").forEach(function (f, i) {
          var meter = f.closest(".meter");
          var val = meter ? meter.style.getPropertyValue("--meter-value") : "";
          setTimeout(function () { f.style.width = val || ""; }, i * 55);
        });
        io.disconnect();
      });
    }, { threshold: 0.15 });
    io.observe(scope);
  }
  document.querySelectorAll("[data-compare]").forEach(animate);
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.hasAttribute("data-compare")) animate(e.target);
    else e.target.querySelectorAll("[data-compare]").forEach(animate);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var header = document.querySelector("[data-header]");
  var U = (window.PhantomR && window.PhantomR.utils) || {};

  /* logo width from settings via CSS vars */
  if (header) {
    header.style.setProperty("--logo-w", "{{ settings.logo_width }}px");
    header.style.setProperty("--logo-w-mobile", "{{ settings.logo_width_mobile }}px");
  }

  /* mega toggle (keyboard / touch) */
  var megaToggle = document.querySelector("[data-mega-toggle]");
  var mega = document.querySelector("[data-mega]");
  var megaItem = megaToggle ? megaToggle.closest("[data-mega-item]") : null;
  function closeMega() {
    if (mega) mega.classList.remove("is-open");
    if (megaToggle) megaToggle.setAttribute("aria-expanded", "false");
  }
  if (megaToggle && mega) {
    megaToggle.addEventListener("click", function () {
      var open = mega.classList.toggle("is-open");
      megaToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    /* click-tap outside the mega item dismisses a click-opened panel */
    document.addEventListener("click", function (e) {
      if (!mega.classList.contains("is-open")) return;
      if (megaItem && megaItem.contains(e.target)) return;
      closeMega();
    });
  }
  document.addEventListener("phantomr:dismiss", function () {
    closeMega();
    closeMobile();
  });

  /* mobile menu */
  var mobile = document.querySelector("[data-mobile-menu]");
  var releaseFocus = null, opener = null;
  function openMobile(btn) {
    mobile.classList.add("is-open"); mobile.setAttribute("aria-hidden", "false");
    if (U.showOverlay) U.showOverlay(); if (U.lockScroll) U.lockScroll();
    opener = btn; releaseFocus = U.trapFocus ? U.trapFocus(mobile, btn) : null;
  }
  function closeMobile() {
    if (!mobile || !mobile.classList.contains("is-open")) return;
    mobile.classList.remove("is-open"); mobile.setAttribute("aria-hidden", "true");
    if (U.hideOverlay) U.hideOverlay(); if (U.unlockScroll) U.unlockScroll();
    if (releaseFocus) { releaseFocus(); releaseFocus = null; }
    document.querySelectorAll("[data-menu-toggle]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
  }
  document.querySelectorAll("[data-menu-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (mobile.classList.contains("is-open")) { closeMobile(); }
      else { btn.setAttribute("aria-expanded", "true"); openMobile(btn); }
    });
  });
  document.querySelectorAll(".mobile-menu__expander").forEach(function (exp) {
    exp.addEventListener("click", function () {
      var open = exp.getAttribute("aria-expanded") === "true";
      exp.setAttribute("aria-expanded", String(!open));
      var sub = exp.nextElementSibling;
      if (sub) sub.hidden = open;
    });
  });

  /* transparent header solidify on scroll */
  if (header && header.dataset.transparent === "true") {
    var solidify = function () { header.classList.toggle("is-solid", window.scrollY > 60); };
    solidify();
    window.addEventListener("scroll", function () { window.requestAnimationFrame(solidify); }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.sct-hero--has-video');
  if (!sections.length) return;

  var reduced = window.PhantomR && window.PhantomR.utils
    ? window.PhantomR.utils.prefersReduced
    : window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach(function (section) {
    var wrap = section.querySelector('[data-hero-video]');
    if (!wrap) return;

    function reveal() {
      var iframe = wrap.querySelector('[data-hero-iframe]');
      if (iframe && iframe.dataset.src && !iframe.getAttribute('src')) {
        iframe.setAttribute('src', iframe.dataset.src);
      }
      var video = wrap.querySelector('video');
      if (video) {
        video.muted = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') { p.catch(function () {}); }
      }
      wrap.hidden = false;
    }

    /* Respect reduced motion: keep the still poster, never autoplay. */
    if (reduced) return;

    /* Defer past the LCP paint so the poster image wins the race. */
    function schedule() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(reveal, { timeout: 1500 });
      } else {
        window.setTimeout(reveal, 600);
      }
    }
    if (document.readyState === 'complete') { schedule(); }
    else { window.addEventListener('load', schedule, { once: true }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  var section = document.querySelector("[data-cart-page]");
  if (!section) return;

  /* cart.js only re-renders the drawer section, so it cannot update this
     page. The cart page therefore owns its own line edits here: it posts to
     the cart change route and reloads so the server-rendered Liquid stays the
     source of truth. Every handler stops propagation so cart.js's global
     delegation never double-fires (or throws when no drawer exists). We only
     hide the no-JS "Update cart" fallback once we know we can take over, so
     the page still degrades to a normal form submit without JS. */
  var routes = (window.PhantomR && window.PhantomR.routes) || {};
  var changeUrl = routes.cartChange;
  if (!changeUrl) return; /* leave the manual Update button visible */

  document.documentElement.classList.add("js");

  var busy = false;

  function commit(key, quantity) {
    if (busy || !key) return;
    busy = true;
    section.classList.add("is-loading");
    fetch(changeUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { window.location.reload(); })
      .catch(function () {
        busy = false;
        section.classList.remove("is-loading");
        /* Network failure: fall back to a full form submit so the edit still
           commits, instead of leaving the page silently out of sync. */
        var form = section.querySelector("#cart");
        if (form) form.submit();
      });
  }

  function readQty(key) {
    var input = section.querySelector('[data-qty-input][data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    return input ? Math.max(0, parseInt(input.value, 10) || 0) : null;
  }

  section.addEventListener("click", function (e) {
    var step = e.target.closest("[data-qty-up], [data-qty-down]");
    if (step) {
      e.preventDefault();
      e.stopPropagation();
      var key = step.getAttribute("data-key");
      var current = readQty(key);
      if (current === null) return;
      var up = step.hasAttribute("data-qty-up");
      var next = Math.max(0, current + (up ? 1 : -1));
      if (next === current) return;
      commit(key, next);
      return;
    }
    var remove = e.target.closest("[data-cart-remove]");
    if (remove) {
      e.preventDefault();
      e.stopPropagation();
      commit(remove.getAttribute("data-key"), 0);
    }
  });

  section.addEventListener("change", function (e) {
    var input = e.target.closest("[data-qty-input]");
    if (!input) return;
    e.stopPropagation();
    commit(input.getAttribute("data-key"), Math.max(0, parseInt(input.value, 10) || 0));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  var section = document.querySelector("[data-collection-section]");
  if (!section) return;
  var sectionId = section.getAttribute("data-section-id");
  var U = (window.PhantomR && window.PhantomR.utils) || {};
  var overlay = section.querySelector("[data-facet-overlay]");

  function activeDescriptor() {
    /* remember which control the user just interacted with so focus can be
       restored after the filter region is replaced */
    var el = document.activeElement;
    if (!el || !section.contains(el)) return null;
    return { name: el.name || null, value: el.value || null, sel: el.getAttribute("data-sort-select") != null ? "[data-sort-select]" : null };
  }
  function restoreFocus(d) {
    if (!d) return;
    var target = null;
    if (d.sel) target = section.querySelector(d.sel);
    else if (d.name) {
      var nodes = section.querySelectorAll('[name="' + (window.CSS && CSS.escape ? CSS.escape(d.name) : d.name) + '"]');
      for (var i = 0; i < nodes.length; i++) { if (nodes[i].value === d.value) { target = nodes[i]; break; } }
      if (!target) target = nodes[0];
    }
    if (target && typeof target.focus === "function") target.focus({ preventScroll: true });
  }

  function fetchAndRender(url, push) {
    section.classList.add("is-loading");
    var focusDesc = activeDescriptor();
    var sep = url.indexOf("?") > -1 ? "&" : "?";
    fetch(url + sep + "section_id=" + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        ["[data-product-grid]", "[data-facets]", "[data-collection-toolbar]"].forEach(function (sel) {
          var fresh = doc.querySelector(sel), live = section.querySelector(sel);
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        });
        /* Freshly-injected cards carry [data-reveal] (hidden until observed),
           but the page-load reveal observer no longer tracks them. Reveal the
           new content immediately so filter/pagination results are visible. */
        section.querySelectorAll("[data-reveal]:not(.is-visible)").forEach(function (el) { el.classList.add("is-visible"); });
        if (push !== false) window.history.pushState({ ph: 1 }, "", url);
        section.classList.remove("is-loading");
        bind();
        /* the focus trap holds references to nodes that were just replaced —
           re-arm it against the fresh markup while the drawer stays open.
           detach the stale keydown listener without refocusing the opener. */
        if (drawerOpen && U.trapFocus && filters) {
          filters.setAttribute("role", "dialog");
          filters.setAttribute("aria-modal", "true");
          if (releaseTrap) releaseTrap(filters, null);
          releaseTrap = U.trapFocus(filters, drawerOpener);
        }
        restoreFocus(focusDesc);
        var top = section.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: U.prefersReduced ? "auto" : "smooth" });
      })
      .catch(function () { section.classList.remove("is-loading"); window.location.href = url; });
  }

  function buildUrl() {
    var form = section.querySelector("[data-facet-form]");
    var base = (form && form.getAttribute("action")) || window.location.pathname;
    var params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach(function (v, k) { if (v !== "" && v != null) params.append(k, v); });
    }
    var sort = section.querySelector("[data-sort-select]");
    if (sort) { params.delete("sort_by"); params.append("sort_by", sort.value); }
    var qs = params.toString();
    return qs ? base + "?" + qs : base;
  }

  function bind() {
    var form = section.querySelector("[data-facet-form]");
    if (form) {
      form.addEventListener("change", function () { fetchAndRender(buildUrl()); });
      form.addEventListener("submit", function (e) { e.preventDefault(); fetchAndRender(buildUrl()); });
    }
    var sort = section.querySelector("[data-sort-select]");
    if (sort) sort.addEventListener("change", function () { fetchAndRender(buildUrl()); });
    section.querySelectorAll("[data-facet-link]").forEach(function (a) {
      a.addEventListener("click", function (e) { e.preventDefault(); fetchAndRender(a.getAttribute("href")); });
    });
  }

  /* mobile drawer */
  var filters = section.querySelector("[data-facets]");
  var drawerOpen = false;
  var releaseTrap = null;
  var drawerOpener = null;
  function openDrawer(opener) {
    if (!filters || drawerOpen) return;
    drawerOpen = true;
    drawerOpener = opener || null;
    filters.classList.add("is-open");
    filters.setAttribute("role", "dialog");
    filters.setAttribute("aria-modal", "true");
    if (overlay) overlay.hidden = false;
    if (U.lockScroll) U.lockScroll();
    if (U.trapFocus) releaseTrap = U.trapFocus(filters, drawerOpener);
  }
  function closeDrawer() {
    if (!filters || !drawerOpen) return;
    drawerOpen = false;
    filters.classList.remove("is-open");
    filters.removeAttribute("role");
    filters.removeAttribute("aria-modal");
    if (overlay) overlay.hidden = true;
    if (U.unlockScroll) U.unlockScroll();
    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
    drawerOpener = null;
  }
  section.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-facet-open]");
    if (opener) { e.preventDefault(); openDrawer(opener); }
    if (e.target.closest("[data-facet-close]") || e.target.closest("[data-facet-overlay]")) closeDrawer();
  });
  document.addEventListener("phantomr:dismiss", closeDrawer);

  window.addEventListener("popstate", function () { fetchAndRender(window.location.href, false); });
  bind();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"]) return;
  try {
    
(function () {
  /* Move keyboard focus to the success or error banner after a submit,
     so assistive tech and keyboard users land on the result. */
  function focusResult(scope) {
    var target = scope.querySelector(".sct-cnt__success, .sct-cnt__errors");
    if (target) {
      try { target.focus(); } catch (e) {}
    }
  }
  document.querySelectorAll(".sct-cnt").forEach(focusResult);
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.classList && e.target.classList.contains("sct-cnt")) focusResult(e.target);
    else e.target.querySelectorAll(".sct-cnt").forEach(focusResult);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var section = document.querySelector("[data-product-section]");
  if (!section) return;
  var U = (window.PhantomR && window.PhantomR.utils) || {};
  var variants = [];
  try { variants = JSON.parse(section.querySelector("[data-variant-json]").textContent); } catch (e) {}

  var picker = section.querySelector("[data-variant-picker]");
  var idInput = section.querySelector("[data-variant-id-input]");
  var atc = section.querySelector("[data-atc]");
  var atcText = section.querySelector("[data-atc-text]");
  var priceBlock = section.querySelector("[data-price-block]");
  var gallery = section.querySelector("[data-gallery]");
  var stickyBar = document.querySelector("[data-sticky-atc]");
  var stickyPrice = document.querySelector("[data-sticky-price]");
  var stickyAdd = document.querySelector("[data-sticky-add]");
  var form = section.querySelector(".product-form");
  var strings = (window.PhantomR && window.PhantomR.strings) || {};
  // Cache the server-rendered, locale-correct GST note so re-renders keep it.
  var taxNoteEl = priceBlock && priceBlock.querySelector(".price__tax");
  var taxNote = taxNoteEl ? taxNoteEl.textContent : "GST included";

  function selectedOptions() {
    var opts = [];
    section.querySelectorAll(".variant-option").forEach(function (fs) {
      var checked = fs.querySelector(".variant-option__input:checked");
      if (checked) opts.push(checked.value);
    });
    return opts;
  }

  function findVariant(opts) {
    return variants.find(function (v) {
      return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  function money(cents) { return U.formatMoney ? U.formatMoney(cents, window.PhantomR.moneyFormat) : "$" + (cents / 100).toFixed(2); }

  function showMedia(mediaId) {
    if (!gallery || !mediaId) return;
    gallery.querySelectorAll(".product-gallery__slide").forEach(function (s) { s.classList.toggle("is-active", s.getAttribute("data-media-id") == mediaId); });
    gallery.querySelectorAll(".product-gallery__thumb").forEach(function (t) { t.classList.toggle("is-active", t.getAttribute("data-thumb") == mediaId); });
  }

  // Cross out option values that have no available variant given the other selections.
  function markAvailability(current) {
    section.querySelectorAll(".variant-option").forEach(function (fs, optIdx) {
      fs.querySelectorAll(".variant-option__input").forEach(function (input) {
        var probe = current.slice();
        probe[optIdx] = input.value;
        var match = variants.find(function (vv) {
          return vv.options.length === probe.length && vv.options.every(function (o, i) { return o === probe[i]; });
        });
        input.classList.toggle("is-unavailable", !(match && match.available));
      });
    });
  }

  function update() {
    if (!picker) return;
    var opts = selectedOptions();
    markAvailability(opts);
    var v = findVariant(opts);
    // update selected-value labels
    section.querySelectorAll("[data-option-selected]").forEach(function (el) {
      var fs = el.closest(".variant-option");
      var checked = fs && fs.querySelector(".variant-option__input:checked");
      if (checked) el.textContent = checked.value;
    });
    if (!v) {
      if (atc) { atc.disabled = true; atc.setAttribute("aria-disabled", "true"); }
      if (atcText) atcText.textContent = strings.unavailable || "Unavailable";
      return;
    }
    if (idInput) idInput.value = v.id;
    var url = new URL(window.location.href);
    url.searchParams.set("variant", v.id);
    window.history.replaceState({}, "", url);
    if (v.featured_media) showMedia(v.featured_media.id);
    // price
    if (priceBlock) {
      var priceEl = priceBlock.querySelector(".price");
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      var html = onSale
        ? '<span class="price__sale">' + money(v.price) + '</span> <s class="price__compare">' + money(v.compare_at_price) + "</s>"
        : '<span class="price__regular">' + money(v.price) + "</span>";
      if (priceEl) {
        priceEl.classList.toggle("price--on-sale", !!onSale);
        priceEl.innerHTML = html + '<span class="price__tax">' + taxNote + "</span>";
      }
    }
    if (stickyPrice) stickyPrice.textContent = money(v.price);
    // availability
    var avail = v.available;
    [atc, stickyAdd].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !avail; btn.setAttribute("aria-disabled", String(!avail));
    });
    if (atcText) atcText.textContent = avail ? (strings.addToCart || "Add to cart") : (strings.soldOut || "Sold out");
  }

  if (picker) picker.addEventListener("change", update);

  // thumbnails
  gallery && gallery.querySelectorAll("[data-thumb]").forEach(function (t) {
    t.addEventListener("click", function () { showMedia(t.getAttribute("data-thumb")); });
  });

  // quantity stepper
  section.querySelectorAll("[data-qty-step]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var field = section.querySelector("[data-qty-field]");
      if (!field) return;
      var val = Math.max(1, (parseInt(field.value, 10) || 1) + parseInt(btn.getAttribute("data-qty-step"), 10));
      field.value = val;
    });
  });

  // add to cart -> hand off to cart.js (drawer) when present, else native submit
  if (form) {
    form.addEventListener("submit", function (e) {
      if (window.PhantomR && window.PhantomR.cart && window.PhantomR.cartType === "drawer") {
        e.preventDefault();
        var qtyField = section.querySelector("[data-qty-field]");
        atc.classList.add("is-loading");
        document.dispatchEvent(new CustomEvent("phantomr:cart:add", { detail: { id: idInput.value, quantity: parseInt(qtyField ? qtyField.value : 1, 10) || 1, button: atc } }));
        setTimeout(function () { atc.classList.remove("is-loading"); }, 1200);
      }
    });
  }
  if (stickyAdd && form) stickyAdd.addEventListener("click", function () { if (form.requestSubmit) form.requestSubmit(); else form.querySelector("[data-atc]").click(); });

  // sticky bar visibility
  if (stickyBar && form) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        stickyBar.hidden = false;
        stickyBar.classList.toggle("is-visible", show);
        stickyBar.setAttribute("aria-hidden", String(!show));
      });
    }, { threshold: 0 });
    io.observe(form);
  }

  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-reel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function activate(card) {
    var poster = card.querySelector('[data-ugc-poster]');
    var btn = card.querySelector('[data-ugc-play]');
    if (!btn) return;
    var kind = btn.getAttribute('data-ugc-play');

    if (kind === 'native') {
      var tpl = card.querySelector('[data-ugc-video]');
      if (!tpl) return;
      var node = tpl.content ? tpl.content.cloneNode(true) : null;
      if (!node) return;
      card.appendChild(node);
      var video = card.querySelector('.sct-ugc__video');
      btn.setAttribute('hidden', '');
      card.classList.add('is-playing');
      if (video && typeof video.play === 'function') {
        var p = video.play();
        if (p && typeof p.catch === 'function') { p.catch(function () {}); }
      }
    } else if (kind === 'embed') {
      var src = btn.getAttribute('data-ugc-embed');
      if (!src) return;
      var iframe = document.createElement('iframe');
      iframe.className = 'sct-ugc__video';
      iframe.setAttribute('src', src);
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', btn.getAttribute('aria-label') || 'Video');
      iframe.setAttribute('loading', 'lazy');
      card.appendChild(iframe);
      btn.setAttribute('hidden', '');
      card.classList.add('is-playing');
    }
    if (poster) { poster.setAttribute('aria-hidden', 'true'); }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ugc-card]').forEach(function (card) {
      if (card.__ugc) return;
      card.__ugc = true;
      var btn = card.querySelector('[data-ugc-play]');
      if (btn) {
        btn.addEventListener('click', function () { activate(card); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
